import * as moment from 'moment';

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { IAccountType } from '../../constants/account-types';
import { FormGroup, FormControl } from '@angular/forms';
import { DemoDataService, IAvailableSession, IBooking } from '../demo-data.service';
import { Subscription } from 'rxjs';
import { LangService } from '../../core/lang.service';
import { IAccountInfo } from '../view-mng-inst-accounts/view-mng-inst-accounts.component';
import { AuthService } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';


enum AccountModal { 
  CANCEL_SESSION    = 'cancel-session',
  STATUS_UPDATE     = 'status-update',
  CHANGE_INVIG      = 'change-invig',
  CHANGE_RESTR      = 'change-restr',
  ADJUST_CAPACITY   = 'adjust-capacity',
  REQ_TRANS_BOOKING = 'req-trans-booking',
  REQ_TRANS_WAITING = 'req-trans-waiting',
}

interface IActiveModal {
  type: AccountModal,
  config: any,
  finish: (config:any)=>void,
  confirmationCaption?:string,
}

@Component({
  selector: 'view-manage-session',
  templateUrl: './view-manage-session.component.html',
  styleUrls: ['./view-manage-session.component.scss']
})
export class ViewManageSessionComponent implements OnInit {

  public breadcrumb = [];
  public AccountModal = AccountModal;
  public nullForm = new FormGroup({}); // to do : remove

  currentModal: IActiveModal;

  bookings = [];
  waitingList = [];

  routeSub:Subscription;

  sessionId:number;
  activeSession:IAvailableSession;
  availableSessions: IAvailableSession[];
  availableInvigilators: Partial<IAccountInfo>[];

  constructor(
    private auth: AuthService, // 
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private route:ActivatedRoute,
    private routes:RoutesService, 
    private demoData:DemoDataService,
    public lang:LangService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_DASHBOARD(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_manage_session'), this.router.url),
    ];
    this.routeSub = this.route.params.subscribe(routeParams => {
      this.sessionId = parseInt(routeParams['sessionId']);
      this.initRouteView()
    });
  }

  isInited:boolean;
  initRouteView(){
    this.auth.user().subscribe(userInfo => {
      if (userInfo && !this.isInited){
        this.isInited = true;
        this.loadSessionData(this.sessionId);
        this.initSelectAllCheckboxes();
      }
    });
  }

  renderInvitationLink(invitationCode:string){
    return [
      this.routes.currentHost(),
      this.lang.c(),
      IAccountType.TEST_TAKER,
      'booking',
      'invite',
      invitationCode
    ].join('/')
  }

  dateRegistrationClose
  loadSessionData(sessionId:number){
    this.activeSession = this.demoData.getSessionById(sessionId);
    this.bookings = this.activeSession.bookings;
    this.waitingList = this.activeSession.waitlist;
    [ this.activeSession.bookings, this.activeSession.waitlist].forEach( list => {
      list.forEach(booking => {
        booking.__isSelected = new FormControl(false);
      })
    })
    this.dateRegistrationClose = moment(this.activeSession.dateTimeStart).subtract(2, 'days')
  }

  allBookingsSelected = new FormControl(false);
  allWaitlistSelected = new FormControl(false);
  initSelectAllCheckboxes(){
    [
      {checkbox: this.allBookingsSelected, bookings: this.bookings},
      {checkbox: this.allWaitlistSelected, bookings: this.waitingList},
    ]
    .forEach(listPairing => {
      listPairing.checkbox.valueChanges.subscribe(isAllSelected => {
        listPairing.bookings.forEach(booking => {
          booking.__isSelected.setValue(isAllSelected);
        })
      })
    })
  }

  getSelected(bookings:IBooking[]){
    const selected = []
    bookings.forEach(booking => {
      if (booking.__isSelected && booking.__isSelected.value){
        selected.push(booking)
      }
    });
    return selected;
  }

  isAnySelected(bookings:IBooking[]){
    let isAnySelected = false
    bookings.forEach(booking => {
      if (booking.__isSelected && booking.__isSelected.value){
        isAnySelected = true;
      }
    });
    return isAnySelected;
  }

  renderLongTimestamp(m:moment.Moment){
    return m.format('h:mma, MMM. D, YYYY (dddd)')
    // 4:30pm, Sept. 22, 2020 (Wednesday)
  }

  renderShortDatestamp(m:moment.Moment){
    if (m){
      return m.format('ddd. MMM. D, YYYY')
    }
  }

  renderShortTimestamp(m:moment.Moment){
    if (m){
      return m.format('MMM. D') + ' at ' + m.format('h:mma')
    }
  }


  getInvigilDisplay(invigilatorId:number){
    const invigil = this.demoData.getInvigilatorBasicInfo(invigilatorId);
    if (invigil){
      let str = invigil.name;
      if (invigil.email){
        str = str + ' ('+invigil.email+')';
      }
      return str;
    }
  }

  getInvigilName(invigilatorId:number){
    const invigil = this.demoData.getInvigilatorBasicInfo(invigilatorId);
    if (invigil){
      return invigil.name;      
    }
  }

  getInvigilEmail(invigilatorId:number, isBracketed:boolean = true){
    const invigil = this.demoData.getInvigilatorBasicInfo(invigilatorId);
    if (invigil){
      if (isBracketed){
        return '('+invigil.email+')';        
      }
      return invigil.email;      
    }
  }

  closeModal = (config?:any) => {
    this.currentModal = null;
  }

  confirmModal(){
    this.currentModal.finish(this.currentModal.config);
  }

  newModal = (modalConfig:IActiveModal) => {
    this.currentModal = modalConfig;
  }

  // CANCEL_SESSION
  cancelSessionModalStart(){
    const config:any = {  }
    this.newModal({
      type: AccountModal.CANCEL_SESSION, 
      config, 
      finish: this.cancelSessionModalFinish,
    });
  }
  cancelSessionModalFinish = (config:any) => {
    this.demoData.cancelSession(this.activeSession.id);
    this.router.navigate([
      this.lang.getCurrentLanguage(),
      IAccountType.TEST_ADMIN,
      'dashboard'
    ])
  }

  // STATUS_UPDATE
  statusUpdateModalStart(){
    const config:any = { 
      newStatus: new FormGroup({msg: new FormControl()})
    }
    this.newModal({
      type: AccountModal.STATUS_UPDATE, 
      config, 
      finish: this.statusUpdateModalFinish,
      confirmationCaption: 'Send',
    });
  }
  statusUpdateModalFinish = (config:any) => {
    const newMsg = config.newStatus.controls.msg.value;
    this.activeSession.status = newMsg;
    this.closeModal();
  }

  // CHANGE_INVIG
  changeInvigModalStart(){
    this.availableInvigilators = this.demoData.getAccounts();
    const config:any = { selection: this.activeSession.inivigilatorId }
    this.newModal({
      type: AccountModal.CHANGE_INVIG, 
      config, 
      finish: this.changeInvigModalFinish,
    });
  }
  changeInvigModalFinish = (config:any) => {
    if (config.selection){
      this.activeSession.inivigilatorId = config.selection;
    }
    this.closeModal();
  }

  getPrintRoute(){
    return  `/${this.lang.c()}/${IAccountType.TEST_ADMIN}/print-session/${this.sessionId}`
  }

  // CHANGE_RESTR
  changeRestrModalStart(){
    const config:any = {  }
    this.newModal({
      type: AccountModal.CHANGE_RESTR, 
      config, 
      finish: this.changeRestrModalFinish,
    });
  }
  changeRestrModalFinish = (config:any) => {
    this.closeModal();
  }

  // ADJUST_CAPACITY
  adjustCapacityModalStart(){
    const config:any = { 
      capacity: new FormGroup({num: new FormControl(this.activeSession.capacity)})
     }
    this.newModal({
      type: AccountModal.ADJUST_CAPACITY, 
      config, 
      finish: this.adjustCapacityModalFinish,
    });
  }
  adjustCapacityModalFinish = (config:any) => {
    const newCapacity = config.capacity.controls.num.value;
    // console.log('value', newCapacity)
    if (newCapacity >= this.activeSession.bookings.length){
      this.activeSession.capacity = newCapacity;
      this.closeModal();
    }
    else{
      config.error = this.lang.tra('txt_error_cannot_decr_low_cap');
    }
  }

  // REQ_TRANS_BOOKING
  reqTransBookingModalStart(){
    this.availableSessions = this.demoData.getTestSessions();
    const config:any = { selection:null, bookings: this.getSelected(this.activeSession.bookings) }
    this.newModal({
      type: AccountModal.REQ_TRANS_BOOKING, 
      config, 
      finish: this.reqTransBookingModalFinish,
    });
  }
  reqTransBookingModalFinish = (config:any) => {
    if (config.selection != null){
      config.bookings.forEach( (booking:IBooking) => {
        booking.reqTransferTimestamp = moment();
      })
    }
    this.closeModal();
  }

  // REQ_TRANS_WAITING
  reqTransWaitingModalStart(){
    this.availableSessions = this.demoData.getTestSessions();
    const config:any = { selection:null, bookings: this.getSelected(this.activeSession.waitlist) }
    this.newModal({
      type: AccountModal.REQ_TRANS_WAITING, 
      config, 
      finish: this.reqTransWaitingModalFinish,
    });
  }
  reqTransWaitingModalFinish = (config:any) => {
    if (config.selection != null){
      config.bookings.forEach( (booking:IBooking) => {
        booking.reqTransferTimestamp = moment();
      })
    }
    this.closeModal();
  }

}
